import { AxiosPromise } from 'axios';
import request from '../network';

// 获取埋点列表
export function list(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/tracking-point/list`,
    method: 'post',
    data,
  });
}

export function paramList(parentId: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/tracking-point/param/list`,
    method: 'post',
    data: {
      pageNum: 1,
      pageSize: 100,
      parentId,
    },
  });
}

// 获取埋点详情
export function detail(params: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/tracking-point/detail`,
    method: 'get',
    params,
  });
}

//创建埋点
export function create(data: any): AxiosPromise<{}> {
  return request({
    url: `/member/royalcanin/admin/tracking-point/create`,
    method: 'post',
    data,
  });
}

//编辑埋点
export function update(data: any): AxiosPromise<{}> {
  return request({
    url: `/member//royalcanin/admin/tracking-point/update`,
    method: 'post',
    data,
  });
}
